/*
 *@description:'正则文件'
*/


/*
 *@description:'登录密码 - 正则密码长度 6-16 位，包含至少一个特殊字符，一个数字，一个大写字母和一个小写字母。'
*/
export function passwordReg(value: string): boolean {
        const reg = /^(?=^.{8,30}$)(?=(?:.*?\d){1})(?=.*[a-z])(?=(?:.*?[A-Z]){1})(?=(?:.*?[`·~!@#$%^&*()_+}{|;'",<.>/?\=\[\]\-\\]){1})(?!.*\s)[0-9a-zA-Z`·~!@#$%^&* ()_+}{|;'",<.>/?\=\[\]\-\\]*$/
        return reg.test(value);
}
/*
 *@description:'登录账号 - 正则 6~30个字符，必须包含字母。可以使用大小写字母、数字、特殊符号（如?@*%.，不支持:）'
*/
export function accountReg(value: string): boolean {
        // (?=^.{6,30}$)  长度6-16
        // (?=(?:.?[`·~!@#$%^&()_+}{:;'",<.>/?=\[\]\-\]){1}) //至少一个特殊字符
        // (?=(?:.*?\d){1})  //至少一个数字
        // (?=.*[a-z])       //a-z的小写字母
        //(?=(?:.*?[A-Z]) //至少一个大写字母
        // (?=(?:.*?\d))(?=.*[a-z])(?=(?:.*?[A-Z]))
        const reg = /^(?=^.{6,30}$)(?=(?:.*?[a-zA-Z]){1})[0-9a-zA-Z`·~!@#$%^&* ()_+}{|;'",<.>/?\=\[\]\-\\]*$/
        return reg.test(value);
}

/*
 *@description:'手机号-正则'
*/
export function phoneReg(value: string): boolean {
        // const reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        return reg.test(value);
};

/*
 *@description:'邮箱 - 正则'
*/
export function emailReg(value: string): boolean {
        const reg =
                /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
        return reg.test(value);
}


/*
 *@description:'身份证-正则'
*/
export function idCardReg(value: string): boolean {
        const reg =
                /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
        return reg.test(value);
};





